// extracted by mini-css-extract-plugin
module.exports = {"logoLink":"flow-header_logoLink__biQZK"};